
window.addEventListener('load', () => {
    handleHeaderScroll();

    // Handle on scroll
    window.addEventListener('scroll', () => {
        handleHeaderScroll();
    })


    function handleHeaderScroll() {
        // Get header
        const header = document.querySelector("[data-scroll='header']");


        if (header) {
            // Check scroll position
            const scrollPosition = window.scrollY;

            // Check if page has been scrolled
            if (scrollPosition > 50) {
                // If true, add class scrolled
                header.classList.add("scrolled");
            }
            else {
                // If not, remove class scrolled
                header.classList.remove("scrolled");
            }

        }
    }

    // get burger element on mobile devices
    const burger = document.querySelector('[data-toggle="burger"]');

    if (burger) {
        // toggle classes and change burger's shape
        burger.addEventListener('click', () => {
            const mobileNav = document.querySelector('[data-toggle="mobile-nav"]');

            if (mobileNav) {
                mobileNav.classList.toggle('hide');
            }

            burger.classList.toggle('shape');

        });
    }
})



